module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "statusRowWhite"
  }, [_c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "size": "medium",
      "type": "primary",
      "icon": "el-icon-back"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")]), _vm._v("\n\t\t\t\t 日期：  \n\t\t\t\t"), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "yesterday"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(1)
      }
    }
  }, [_vm._v("昨天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "yesterday"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(2)
      }
    }
  }, [_vm._v("前天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "id": "yesterday"
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(7)
      }
    }
  }, [_vm._v("最近7天")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function($event) {
        return _vm.changeDate(30)
      }
    }
  }, [_vm._v("最近30天")])], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 日期筛选：  \n\t\t\t\t"), _c('el-date-picker', {
    staticClass: "xs24",
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "今天",
      "format": "yyyy 年 MM 月 dd 日",
      "value-format": "yyyy-MM-dd",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.dateVal),
      callback: function($$v) {
        _vm.dateVal = $$v
      },
      expression: "dateVal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 游戏来源：  \n\t\t\t\t "), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: (_vm.pdata.source),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "source", $$v)
      },
      expression: "pdata.source"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "内部游戏",
      "value": "内部游戏"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "外部游戏",
      "value": "外部游戏"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 平台来源：  \n\t\t\t\t"), _c('el-select', {
    staticClass: "xs24",
    attrs: {
      "placeholder": "请选择小游戏来源"
    },
    on: {
      "change": _vm.changePlatform
    },
    model: {
      value: (_vm.pdata.platform_id),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "platform_id", $$v)
      },
      expression: "pdata.platform_id"
    }
  }, _vm._l((_vm.get_issued_app_platform), function(v, i) {
    return _c('el-option', {
      key: v.platform_id,
      attrs: {
        "label": v.platform_name,
        "value": v.platform_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_vm._v("\n\t\t\t\t 小游戏名称：  \n\t\t\t\t"), _c('searchApp', {
    staticClass: "xs24",
    attrs: {
      "platform_id": _vm.pdata.platform_id.toString(),
      "compare": "issued",
      "pholder": _vm.pholder
    },
    on: {
      "getid": _vm.changeId
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "RowChild"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportIncome
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.fieldConfig
    }
  }, [_vm._v("字段选择")])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "background": "#fff"
    }
  }, [(_vm.list.length > 0) ? _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "stripe": "",
      "row-key": "id",
      "show-summary": "",
      "summary-method": _vm.getSummaries,
      "height": _vm.height
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "d_date",
      "label": "日期",
      "align": "center",
      "min-width": "120px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "issued_app_name",
      "label": "发行名称",
      "align": "center",
      "min-width": "120px"
    }
  }), _vm._v(" "), _vm._l((_vm.showFieldList), function(item) {
    return _c('el-table-column', {
      attrs: {
        "prop": item.key,
        "label": item.name,
        "align": "center",
        "sortable": "",
        "sort-method": function (a, b) {
          return parseFloat(a[item.key]) - parseFloat(b[item.key])
        }
      }
    })
  })], 2) : _vm._e(), _vm._v(" "), (_vm.list.length == 0) ? _c('div', {
    staticClass: "el-table el-table--fit el-table--striped el-table--enable-row-hover",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "el-table__body-wrapper is-scrolling-none"
  }, [_c('div', {
    staticClass: "el-table__empty-block",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('span', {
    staticClass: "el-table__empty-text"
  }, [_vm._v("暂无数据")])])])]) : _vm._e(), _vm._v(" "), _c('el-pagination', {
    staticClass: "pagination",
    attrs: {
      "current-page": _vm.pdata.page,
      "page-sizes": [20, 40, 60, 80],
      "page-size": _vm.pdata.perpage,
      "background": "",
      "layout": "sizes, prev, pager, next, jumper",
      "total": _vm.pdata.perpage * _vm.maxPage
    },
    on: {
      "size-change": _vm.SizeChange,
      "current-change": _vm.CurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.pdata, "page", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑创意组合",
      "visible": _vm.editDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.group
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "导出选择",
      "visible": _vm.checkDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.checkDialog = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "margin": "10px 0"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-checkbox', {
    attrs: {
      "indeterminate": _vm.isIndeterminate
    },
    on: {
      "change": _vm.handleCheckAllChange
    },
    model: {
      value: (_vm.checkAll),
      callback: function($$v) {
        _vm.checkAll = $$v
      },
      expression: "checkAll"
    }
  }, [_vm._v("全选")])], 1)], 1), _vm._v(" "), (_vm.activeType == 0) ? _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist0), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeType == 1) ? _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist1), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeType == 2) ? _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist2), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeType == 3) ? _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist3), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.activeType == 4) ? _c('el-row', [_c('el-checkbox-group', {
    on: {
      "change": _vm.handleCheckedChange
    },
    model: {
      value: (_vm.checks),
      callback: function($$v) {
        _vm.checks = $$v
      },
      expression: "checks"
    }
  }, [_c('el-row', _vm._l((_vm.checklist4), function(item) {
    return _c('el-col', {
      staticStyle: {
        "margin": "10px 0"
      },
      attrs: {
        "span": 6
      }
    }, [_c('el-checkbox', {
      key: item.value,
      attrs: {
        "label": item
      }
    }, [_vm._v(_vm._s(item.name))])], 1)
  }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleDownload
    }
  }, [_vm._v("确定")])], 1)], 1)], 1), _vm._v(" "), _c('el-drawer', {
    attrs: {
      "title": "我是标题",
      "size": "580px",
      "visible": _vm.drawer,
      "direction": "rtl",
      "with-header": false
    },
    on: {
      "update:visible": function($event) {
        _vm.drawer = $event
      }
    }
  }, [_c('el-tabs', {
    attrs: {
      "type": "card"
    },
    on: {
      "tab-click": _vm.fieldListChange
    },
    model: {
      value: (_vm.FieldIndex),
      callback: function($$v) {
        _vm.FieldIndex = $$v
      },
      expression: "FieldIndex"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "按字段设置",
      "name": "0"
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "des"
  }, [_c('span', [_vm._v("可选字段")]), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTap(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _c('draggable', {
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.selectFieldList),
      callback: function($$v) {
        _vm.selectFieldList = $$v
      },
      expression: "selectFieldList"
    }
  }, [_c('transition-group', {
    attrs: {
      "type": "transition",
      "tag": "ul"
    }
  }, _vm._l((_vm.selectFieldList), function(item) {
    return _c('li', {
      key: item.key,
      staticClass: "item"
    }, [_c('i', {
      staticClass: "el-icon-rank"
    }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t\t"), _c('i', {
      staticClass: "el-icon-close",
      on: {
        "click": function($event) {
          return _vm.removeSelectField(item)
        }
      }
    })])
  }), 0)], 1)], 1)])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "按模块设置",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "filedFlex"
  }, [_c('div', {
    staticClass: "fliedLeft"
  }, [_c('div', {
    staticClass: "des"
  }, [_c('span', [_vm._v("可选字段")]), _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1), _vm._v(" "), _vm._l((_vm.fieldList), function(value, key) {
    return _c('div', {
      staticClass: "fliedBtns"
    }, [_c('div', {
      staticClass: "key"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('div', {
      staticClass: "btnsbox"
    }, _vm._l((value), function(item, index) {
      return _c('el-button', {
        attrs: {
          "type": item.isCheck ? 'primary' : '',
          "plain": item.isCheck ? false : true,
          "size": "mini",
          "autofocus": false
        },
        nativeOn: {
          "click": function($event) {
            return _vm.fliedTapForModel(key, index)
          }
        }
      }, [_vm._v(_vm._s(item.name))])
    }), 1)])
  }), _vm._v(" "), _c('div', {
    staticClass: "fliedFt"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.saveSelectField
    }
  }, [_vm._v("确认并保存")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "fliedRight"
  }, [_c('div', {
    staticClass: "tit"
  }, [_vm._v("已选字段")]), _vm._v(" "), _vm._l((_vm.selectFieldListForModel), function(value, key, index) {
    return _c('div', {
      staticClass: "fliedModel"
    }, [_c('div', {
      staticClass: "fliedModelKey"
    }, [_vm._v(_vm._s(key))]), _vm._v(" "), _c('draggable', {
      attrs: {
        "move": _vm.onMove
      },
      on: {
        "start": function($event) {
          _vm.isDragging = true
        },
        "end": function($event) {
          _vm.isDragging = false
        }
      },
      model: {
        value: (_vm.selectFieldListForModel[key]),
        callback: function($$v) {
          _vm.$set(_vm.selectFieldListForModel, key, $$v)
        },
        expression: "selectFieldListForModel[key]"
      }
    }, [_c('transition-group', {
      attrs: {
        "type": "transition",
        "tag": "ul"
      }
    }, _vm._l((value), function(item) {
      return _c('li', {
        key: item.key,
        staticClass: "item"
      }, [_c('i', {
        staticClass: "el-icon-rank"
      }), _vm._v(" " + _vm._s(item.name) + "\n\t\t\t\t\t\t\t\t\t\t\t"), _c('i', {
        staticClass: "el-icon-close",
        on: {
          "click": function($event) {
            return _vm.removeSelectFieldForModel(item, key)
          }
        }
      })])
    }), 0)], 1)], 1)
  })], 2)])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-982c78ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/daily/productDailyDetail.vue
// module id = 1148
// module chunks = 2